@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="loginForm" (ngSubmit)="submit()">
  <bmcore-input formControlName="email" [title]="'Email'" [type]="'email'" [controlFormName]="'email'"> </bmcore-input>
  <bmcore-input formControlName="password" [title]="'Password'" [type]="'password'" [controlFormName]="'password'">
  </bmcore-input>

  <div class="login-form__password-hint">
    <a class="bm--auth-form__hint" routerLink="/restore-password"> Forgot Password? </a>
  </div>

  <div class="bm--auth-form-btn-container">
    <bmcore-button title="Sign in" styleName="center" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
